import React, { forwardRef, useCallback, useContext, useRef } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import classnames from 'classnames';
import { ThemeContext } from 'styled-components';
import { updateReceiptField } from '../../actions/formData';
import emailValidatorConfig from '../../constants/emailValidatorConfig';
import useCombinedRefs from '../hooks/useCombinedRefs';
import Checkbox from '../ui/Checkbox';
import ValidateInput from '../ui/ValidateInput';

const GetReceiptCheckboxWithInput = forwardRef(({ hidden, forceStateShowIfTouched, onValidate }, ref) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const themeContext = useContext(ThemeContext);
  const { getReceipt, receiptEmail, _receiptEmail } = useSelector(state => state.formData);
  const inputRef = useRef();
  const roundedInputsCheckboxLabels = getReceipt ? t('methods.dont_need_receipt') : t('methods.get_receipt_rounded');

  const handleCheckboxChange = useCallback((value) => {
    dispatch(updateReceiptField('getReceipt', value));
    setTimeout(() => {
      inputRef.current.validate();
    }, 0);
  }, []);

  const handleEmailChange = useCallback((value, rawValue) => {
    dispatch(updateReceiptField('receiptEmail', value));
    dispatch(updateReceiptField('_receiptEmail', rawValue));
  }, []);

  return (
    <div className={classnames('footer-row get-receipt-checkbox-with-input', { hidden, rounded: themeContext.inputStyle === 'rounded', dark: themeContext.formTheme === 'dark' })}>
      <div className={classnames('footer-cell checkbox-wrap', { collapsed: !getReceipt })}>
        <Checkbox
          value={getReceipt}
          label={themeContext.inputStyle === 'rounded' ? roundedInputsCheckboxLabels : t('methods.get_receipt')}
          onChange={handleCheckboxChange}
        />
      </div>
      <div className="footer-cell input-wrap">
        <ValidateInput
          ref={useCombinedRefs(ref, inputRef)}
          className={classnames({ hidden: !getReceipt })}
          tabIndex={getReceipt ? '0' : '-1'}
          forceStateShowIfTouched={forceStateShowIfTouched}
          type="email"
          label="Введите email"
          name="receiptEmail"
          autoComplete="email"
          value={receiptEmail}
          defaultValue={_receiptEmail}
          onChange={handleEmailChange}
          validator={value => onValidate(value, emailValidatorConfig, 'receiptEmail')}
          iconPath="assets/svg/mail.svg"
        />
      </div>
    </div>
  );
});

GetReceiptCheckboxWithInput.propTypes = {
  hidden: PropTypes.bool,
  forceStateShowIfTouched: PropTypes.bool,
  onValidate: PropTypes.func.isRequired,
};

GetReceiptCheckboxWithInput.defaultProps = {
  hidden: false,
  forceStateShowIfTouched: false,
};

export default GetReceiptCheckboxWithInput;
